export default __webpack_public_path__ + "static/media/competitions.eeb80f30.svg";